import React, { useEffect, useState } from 'react';
import { AppShell } from '@/components/nav/AppShell';
import { jobsApi } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { JobStatusPill } from '@/components/jobs/JobStatusPill';
import { fmtDate } from '@/lib/format';
import { EmptyState } from '@/components/empty/EmptyState';
import { ListSkeleton } from '@/components/common/ListSkeleton';
import { Briefcase, ArrowRight } from 'lucide-react';
import { useAuth } from '@/lib/auth';

export default function MyDayPage() {
  const [jobs, setJobs] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    jobsApi.list()
      .then(setJobs)
      .catch(() => {}) // surfaced by the api response interceptor
      .finally(() => setLoaded(true));
  }, []);

  const active = jobs.filter(j => !['cancelled', 'paid', 'refunded'].includes(j.status));
  const done = jobs.filter(j => ['finished', 'invoiced', 'paid'].includes(j.status));

  return (
    <AppShell title="My Day">
      <div className="mb-6">
        <h1 className="font-display text-2xl font-semibold">Hi, {user?.name?.split(' ')[0]}</h1>
        <p className="text-sm text-muted-foreground">Here's your day. Tap a job to get started.</p>
      </div>

      {!loaded ? (
        <ListSkeleton rows={4} />
      ) : active.length === 0 ? (
        <EmptyState icon={Briefcase} title="No active jobs today" description="Enjoy your day off, or ask your dispatcher for assignments." />
      ) : (
        <div className="space-y-3">
          {active.map(j => (
            <Link key={j.id} to={`/jobs/${j.id}`} className="block">
              <Card className="hover:border-primary/50">
                <CardContent className="p-4">
                  <div className="flex items-center justify-between">
                    <div className="min-w-0">
                      <div className="font-semibold text-sm">Job {j.id.slice(0, 6)}</div>
                      <div className="text-xs text-muted-foreground">{fmtDate(j.scheduled_at)} • {j.duration_hours || 3}h</div>
                    </div>
                    <div className="flex items-center gap-2">
                      <JobStatusPill status={j.status} />
                      <ArrowRight className="h-4 w-4 text-muted-foreground" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}

      {done.length > 0 && (
        <div className="mt-6">
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-2">Completed</div>
          <div className="space-y-2">
            {done.map(j => (
              <Link key={j.id} to={`/jobs/${j.id}`} className="block">
                <Card><CardContent className="p-3 flex items-center justify-between">
                  <div className="text-sm">Job {j.id.slice(0, 6)} • {fmtDate(j.scheduled_at)}</div>
                  <JobStatusPill status={j.status} />
                </CardContent></Card>
              </Link>
            ))}
          </div>
        </div>
      )}
    </AppShell>
  );
}
